export const EXCMUSERDATASTATUS_DELETE_RESET = 'EXCMUSERDATASTATUS_DELETE_RESET'
export const EXCMUSERDATASTATUS_DELETE_SET_ERROR = 'EXCMUSERDATASTATUS_DELETE_SET_ERROR'
export const EXCMUSERDATASTATUS_DELETE_SET_DELETED = 'EXCMUSERDATASTATUS_DELETE_SET_DELETED'
export const EXCMUSERDATASTATUS_DELETE_TOGGLE_LOADING = 'EXCMUSERDATASTATUS_DELETE_TOGGLE_LOADING'
